import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ErrorComponent from "./ErrorComponent";
import axios from "api/axios";
import AuthContext from "Context/AuthProvider";
import { useContext, useEffect, useState } from "react";
import DragAndDrop from "./DragAndDrop";
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function PropertyComponent({ title, data: param }) {
  const [fileList, setFileList] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const { state, dispatch } = useContext(AuthContext);
  const { adminLogin } = state;
  const navigate = useNavigate();
  const schema = yup.object({
    property_type: yup.string().required(),
    purpose_type: yup.string().required(),
    isFeatured: yup.string().required(),
    building_size: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    title: yup.string().required(),
    building_size_measure: yup
      .string()
      .nullable(true)
      .transform((_, val) => (val ? String(val) : null)),
    lot_size: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    lot_size_measure: yup
      .string()
      .nullable(true)
      .transform((_, val) => (val ? String(val) : null)),
    description: yup.string().required(),
    price: yup.number().typeError("price should be a number").required(),
    built: yup.number().typeError("year built should be a number").required(),
    city: yup.string().required(),
    videos: yup
      .string()
      .nullable(true)
      .transform((_, val) => (val ? val : null)),
    zip_code: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    street: yup.string().required(),
    str_no: yup
      .string("Street number must be a string")
      .nullable(true)
      .transform((_, val) => (val ? String(val) : null)),
    bedrooms: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    bathrooms: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    total_room: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    garage_space: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    basement: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
    loft: yup
      .number()
      .nullable(true)
      .transform((_, val) => (val ? Number(val) : null)),
  });

  // handle the validation before the modal..
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      property_type: "",
      purpose_type: "",
      building_size: "",
      title: "",
      isFeatured: false,
      building_size_measure: "",
      lot_size: "",
      lot_size_measure: "",
      description: "",
      price: "",
      built: "",
      city: "",
      videos: "",
      zip_code: "",
      street: "",
      str_no: "",
      bedrooms: "",
      bathrooms: "",
      total_room: "",
      garage_space: "",
      basement: "",
      loft: "",
    },
  });
  const { onChange, ...rest } = register("");
  const [loading, setLoading] = useState(false);
  const onSubmit = async (body) => {
    if (
      fileList &&
      fileList.length > 0 &&
      location?.pathname === "/dashboard/add_property"
    ) {
      try {
        setLoading(true);
        const { data } = await axios.post(
          "/listing",
          { ...body, images: fileList },
          {
            headers: {
              Authorization: `Bearer ${adminLogin?.accessToken}`,
            },
          }
        );
        enqueueSnackbar(data?.message);
        setLoading(false);
      } catch (error) {
        const err = error?.response
          ? error.response.data.message
          : error.message;
        enqueueSnackbar(err, { variant: "error" });
        setLoading(false);
        if (error?.response?.data?.message === "expired token") {
          dispatch({ type: "ADMIN_LOGOUT" });
          localStorage.removeItem("adminInfo");
          navigate("/adminlogin", { state: { from: location } });
        }
      }
    } else {
      try {
        setLoading(true);
        const { data } = await axios.put(
          `/updateListing/${param}`,
          { ...body },
          {
            headers: {
              Authorization: `Bearer ${adminLogin?.accessToken}`,
            },
          }
        );
        enqueueSnackbar(data?.message, { variant: "success" });
        setLoading(false);
      } catch (error) {
        const err = error?.response
          ? error.response.data.message
          : error.message;
        enqueueSnackbar(err, { variant: "error" });
        setLoading(false);
        if (error?.response?.data?.message === "expired token") {
          dispatch({ type: "ADMIN_LOGOUT" });
          localStorage.removeItem("adminInfo");
          navigate("/adminlogin", { state: { from: location } });
        }
      }
    }
  };
  // get all listings...
  useEffect(() => {
    if (location?.pathname !== "/dashboard/add_property") {
      const getMessage = async () => {
        try {
          const { data } = await axios.get(`/singleListings/${param}`);
          reset({
            property_type: data?.message[0].property_type,
            purpose_type: data?.message[0].purpose_type,
            building_size: data?.message[0].building_size,
            title: data?.message[0].title,
            building_size_measure: data?.message[0].building_size_measure,
            lot_size: data?.message[0].lot_size,
            lot_size_measure: data?.message[0].lot_size_measure,
            description: data?.message[0].description,
            isFeatured: data?.message[0].isFeatured,
            price: data?.message[0].price,
            built: data?.message[0].built,
            city: data?.message[0].city,
            videos: data?.message[0].videos,
            zip_code: data?.message[0].zip_code,
            street: data?.message[0].street,
            str_no: data?.message[0].str_no,
            bedrooms: data?.message[0].bedrooms,
            bathrooms: data?.message[0].bathrooms,
            total_room: data?.message[0].total_room,
            garage_space: data?.message[0].garage_space,
            basement: data?.message[0].basement,
            loft: data?.message[0].loft,
          });
          // console.log(data);
        } catch (error) {
          // error && navigate("/adminlogin", { state: { from: location } });
          const errorM = error?.response
            ? error.response?.data.message
            : error.message;

          enqueueSnackbar(errorM, { variant: "error" });
        }
      };
      getMessage();
    }
  }, [param, location?.pathname, reset, enqueueSnackbar]);

  return (
    <div className="edit_property">
      <h3 className="heading">{title}</h3>
      <div className="form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="general_fields">
            <h1 className="title">General</h1>
            <div className="input_wrapper">
              <div className="input_label">
                <label htmlFor="">Property Type</label>
                <select {...register("property_type")}>
                  <option value="Single Family">Single Family</option>
                  <option value="Condo">Condo</option>
                  <option value="Villa">Villa</option>
                </select>
                <ErrorComponent errors={errors} name="property_type" />
              </div>
              <div className="input_label">
                <label htmlFor="">Style / Purpose</label>
                <select {...register("purpose_type")}>
                  <option value="low-rise">low-rise</option>
                  <option value="High-rise">High-rise</option>
                </select>
                <ErrorComponent errors={errors} name="purpose_type" />
              </div>
              <div className="input_label">
                <label htmlFor="">Title</label>
                <input
                  type="text"
                  placeholder="name of the housing"
                  {...register("title")}
                />
                <ErrorComponent errors={errors} name="title" />
              </div>
            </div>
            <div className=" trouble">
              <div className="input_label">
                <label htmlFor="">Building Size</label>
                <div className="input_select">
                  <div className="input_main">
                    <input type="number" {...register("building_size")} />
                    <ErrorComponent errors={errors} name="building_size" />
                  </div>
                  <div className="select_main">
                    <select {...register("building_size_measure")}>
                      <option value="Sqm">Sqm</option>
                      <option value="ft">ft</option>
                    </select>
                    <ErrorComponent
                      errors={errors}
                      name="building_size_measure"
                    />
                  </div>
                </div>
              </div>
              <div className="input_label">
                <label htmlFor="">Lot Size</label>
                <div className="input_select">
                  <div className="input_main">
                    <input type="number" name="" {...register("lot_size")} />
                    <ErrorComponent errors={errors} name="lot_size" />
                  </div>
                  <div className="select_main">
                    <select name="" {...register("lot_size_measure")}>
                      <option value="Sqm">Sqm</option>
                      <option value="Ft">Ft</option>
                    </select>
                    <ErrorComponent errors={errors} name="lot_size_measure" />
                  </div>
                </div>
              </div>
            </div>
            <div className="input_area">
              <label htmlFor="">Description</label>
              <textarea
                name=""
                id=""
                cols="30"
                rows="10"
                {...register("description")}
                placeholder="write a detailed description about the product"
              ></textarea>
              <ErrorComponent errors={errors} name="description" />
            </div>
            <div className="input_price_built">
              <div className="price">
                <label htmlFor="">Price</label>
                <input type="number" name="" {...register("price")} />
                <ErrorComponent errors={errors} name="price" />
              </div>
              <div className="built">
                <label htmlFor="">Year built</label>
                <input type="number" {...register("built")} />
                <ErrorComponent errors={errors} name="built" />
              </div>
            </div>
          </div>
          <div className="location">
            <h1 className="title">Location</h1>
            <div className="input_section">
              <div className="input_label">
                <label htmlFor="">City</label>
                <input type="text" {...register("city")} />
                <ErrorComponent errors={errors} name="city" />
              </div>
              <div className="input_label_wrapper">
                <div className="input_label">
                  <label htmlFor="">Zip Code</label>
                  <input type="text" {...register("zip_code")} />
                  <ErrorComponent errors={errors} name="zip_code" />
                </div>
                <div className="input_label">
                  <label htmlFor="">Street</label>
                  <input type="text" {...register("street")} />
                  <ErrorComponent errors={errors} name="street" />
                </div>
                <div className="input_label">
                  <label htmlFor="">Number</label>
                  <input type="text" {...register("str_no")} />
                  <ErrorComponent errors={errors} name="str_no" />
                </div>
              </div>
            </div>
          </div>
          <div className="location space other">
            <h1 className="title">Others</h1>
            <div className="input_label">
              <label htmlFor="">isFeatured</label>
              <select {...register("isFeatured")}>
                <option value="true">true</option>
                <option value="false">false</option>
              </select>
              <ErrorComponent errors={errors} name="isFeatured" />
            </div>
          </div>
          <div className="location space">
            <h1 className="title">Space</h1>
            <div className="input_section">
              <div className="input_label_wrapper">
                <div className="input_label">
                  <label htmlFor="">Bedrooms</label>
                  <input type="number" {...register("bedrooms")} />
                  <ErrorComponent errors={errors} name="bedrooms" />
                </div>
                <div className="input_label">
                  <label htmlFor="">Bathrooms</label>
                  <input type="number" {...register("bathrooms")} />
                  <ErrorComponent errors={errors} name="bathrooms" />
                </div>
                <div className="input_label">
                  <label htmlFor="">Total rooms</label>
                  <input type="number" {...register("total_room")} />
                  <ErrorComponent errors={errors} name="total_room" />
                </div>
              </div>
              <div className="input_label_wrapper">
                <div className="input_label">
                  <label htmlFor="">Garage Space</label>
                  <input type="number" {...register("garage_space")} />
                  <ErrorComponent errors={errors} name="garage_space" />
                </div>
                <div className="input_label">
                  <label htmlFor="">Basement</label>
                  <input type="number" {...register("basement")} />
                  <ErrorComponent errors={errors} name="basement" />
                </div>
                <div className="input_label">
                  <label htmlFor="">Loft</label>
                  <input type="number" {...register("loft")} />
                  <ErrorComponent errors={errors} name="loft" />
                </div>
              </div>
            </div>
          </div>
          <div className="location space">
            <h1 className="title">Upload new images</h1>
            <DragAndDrop
              title="Drag 'n' drop some images here, or click to select images"
              handleFileList={setFileList}
              fileList={fileList}
            />
          </div>
          <div className="location space video">
            <h1 className="title">Upload Video</h1>
            {/* <DragAndDropVideo
              title="you can drag or drop video here"
              handleVideo={setVideos}
            /> */}

            <div className="input_label">
              <label htmlFor="">video</label>
              <input
                type="text"
                {...register("videos")}
                placeholder="paste your video link"
              />
              <ErrorComponent errors={errors} name="videos" />
            </div>
          </div>
          <div className="btn_wrapper">
            {location?.pathname === "/dashboard/add_property" ? (
              <>
                <button type="submit">
                  {loading ? (
                    <PulseLoader color={"#F37A24"} loading={loading} size={5} />
                  ) : (
                    <span>Upload</span>
                  )}
                </button>
              </>
            ) : (
              <>
                <button style={{ display: "none" }}>Cancel</button>
                <button type="submit">
                  {loading ? (
                    <PulseLoader color={"#F37A24"} loading={loading} size={5} />
                  ) : (
                    <span>Update</span>
                  )}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
